import {
  ADMIN_MED_LIST_REQUEST,
  ADMIN_MED_LIST_SUCCESS,
  ADMIN_MED_LIST_FAIL,
  ADMIN_MED_CREATE_REQUEST,
  ADMIN_MED_CREATE_SUCCESS,
  ADMIN_MED_CREATE_FAIL,
  ADMIN_MED_UPDATE_REQUEST,
  ADMIN_MED_UPDATE_SUCCESS,
  ADMIN_MED_UPDATE_FAIL,
  ADMIN_MED_DELETE_REQUEST,
  ADMIN_MED_DELETE_SUCCESS,
  ADMIN_MED_DELETE_FAIL,
  ADMIN_MED_ADD_STOCK_REQUEST,
  ADMIN_MED_ADD_STOCK_SUCCESS,
  ADMIN_MED_ADD_STOCK_FAIL,
  ADMIN_MED_REPORT_REQUEST,
  ADMIN_MED_REPORT_SUCCESS,
  ADMIN_MED_REPORT_FAIL,
  ADMIN_MED_TOP_REQUEST,
  ADMIN_MED_TOP_SUCCESS,
  ADMIN_MED_TOP_FAIL,
  ADMIN_MED_SELL_REQUEST,
  ADMIN_MED_SELL_SUCCESS,
  ADMIN_MED_SELL_FAIL,
} from "../../constants/adminConstants/adminMedicineConstants.js";

const initialState = {
  medicines: [],
  report: [],
  topSelling: [],
  loading: false,
  error: null,
};

const getUpdated = (p) => (p?.medicine ? p.medicine : p);

export const adminMedicineReducer = (state = initialState, action) => {
  switch (action.type) {
    // REQUEST
    case ADMIN_MED_LIST_REQUEST:
    case ADMIN_MED_CREATE_REQUEST:
    case ADMIN_MED_UPDATE_REQUEST:
    case ADMIN_MED_DELETE_REQUEST:
    case ADMIN_MED_ADD_STOCK_REQUEST:
    case ADMIN_MED_REPORT_REQUEST:
    case ADMIN_MED_TOP_REQUEST:
    case ADMIN_MED_SELL_REQUEST:
      return { ...state, loading: true, error: null };

    // LIST
    case ADMIN_MED_LIST_SUCCESS:
      return { ...state, loading: false, medicines: action.payload };

    // CREATE
    case ADMIN_MED_CREATE_SUCCESS:
      return {
        ...state,
        loading: false,
        medicines: [...state.medicines, action.payload],
      };

    // UPDATE & ADD STOCK
    case ADMIN_MED_UPDATE_SUCCESS:
    case ADMIN_MED_ADD_STOCK_SUCCESS: {
      const updated = getUpdated(action.payload);
      return {
        ...state,
        loading: false,
        medicines: state.medicines.map((m) =>
          m._id === updated._id ? updated : m
        ),
      };
    }

    // DELETE
    case ADMIN_MED_DELETE_SUCCESS:
      return {
        ...state,
        loading: false,
        medicines: state.medicines.filter((m) => m._id !== action.payload),
      };

    // REPORT
    case ADMIN_MED_REPORT_SUCCESS:
      return { ...state, loading: false, report: action.payload };

    // TOP SELLING
    case ADMIN_MED_TOP_SUCCESS:
      return { ...state, loading: false, topSelling: action.payload };

    // SELL
    case ADMIN_MED_SELL_SUCCESS: {
      const updated = getUpdated(action.payload);
      return {
        ...state,
        loading: false,
        medicines: state.medicines.map((m) =>
          m._id === updated._id ? updated : m
        ),
      };
    }

    // FAIL
    case ADMIN_MED_LIST_FAIL:
    case ADMIN_MED_CREATE_FAIL:
    case ADMIN_MED_UPDATE_FAIL:
    case ADMIN_MED_DELETE_FAIL:
    case ADMIN_MED_ADD_STOCK_FAIL:
    case ADMIN_MED_REPORT_FAIL:
    case ADMIN_MED_TOP_FAIL:
    case ADMIN_MED_SELL_FAIL:
      return { ...state, loading: false, error: action.payload };

    default:
      return state;
  }
};
